import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { GraphQLTypes } from '../lib/graphqlTypes';

export const useTrackMutation = () => {
  const [trackMutation] = useMutation<
    GraphQLTypes.TrackMutation,
    GraphQLTypes.TrackMutationVariables
  >(gql`
    mutation TrackMutation(
      $event: EventEnum!
      $graphVariant: String!
      $graphID: String!
    ) {
      track(event: $event, graphVariant: $graphVariant, graphID: $graphID)
    }
  `);

  return useCallback(
    (variables: GraphQLTypes.TrackMutationVariables) => {
      return trackMutation({
        variables: {
          ...variables,
          graphVariant: variables.graphVariant || 'n/a',
        },
      });
    },
    [trackMutation],
  );
};
